var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames, entityTypeNameFor } from '@shapeable/utils';
import AnimateHeight from 'react-animate-height';
import { MoreDivider } from '../elements/more-divider';
import { useIsAside } from '../hooks/use-layout-target';
import { useLang } from '../hooks/use-lang';
import { useEntityTypeValues } from '../hooks/use-entity-type-values';
import { EntityLink } from './entity-link';
import { EntityValue } from './entity-value';
import { CellHeader } from '../elements/cell-header';
import { compact } from 'lodash';
import { useComponentPropsFor } from '../context/component-props-context';
var cls = classNames('entity-meta-section');
export var EntityMetaSectionDefaultProps = {
  maxItems: 2,
  spacing: 4,
  showAllItems: true,
  direction: 'column',
  color: 'strong'
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var LabelStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    padding-bottom: ", ";\n    color: ", ";\n    font-weight: 300;\n  "], ["\n    padding-bottom: ", ";\n    color: ", ";\n    font-weight: 300;\n  "])), theme.UNIT(2), theme.COLOR('text-mid'))
});
var ItemsStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    flex-direction: column;\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    width: 100%;\n    margin-top: ", ";\n    margin-bottom: ", ";\n    align-items: flex-start;\n  \n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    &:first-child {\n      margin-top: 0;\n    }\n\n    ", "\n  "], ["\n    display: flex;\n    flex-direction: column;\n    list-style: none;\n    margin: 0;\n    padding: 0;\n    width: 100%;\n    margin-top: ", ";\n    margin-bottom: ", ";\n    align-items: flex-start;\n  \n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    &:first-child {\n      margin-top: 0;\n    }\n\n    ", "\n  "])), theme.UNIT(2), theme.UNIT(4), function (_a) {
    var spacing = _a.spacing;
    return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      gap: ", ";\n    "], ["\n      gap: ", ";\n    "])), theme.UNIT(spacing));
  }),
  tablet: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    flex-direction: ", ";\n    flex-wrap: wrap;\n    align-items: flex-start;\n  "], ["\n    flex-direction: ", ";\n    flex-wrap: wrap;\n    align-items: flex-start;\n  "])), function (_a) {
    var direction = _a.direction;
    return direction;
  })
});
var ItemStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    \n    ", "\n    \n    ", "\n    \n  "], ["\n    \n    ", "\n    \n    ", "\n    \n  "])), function (_a) {
    var count = _a.count,
      direction = _a.direction;
    return direction === 'row' && count > 1 && css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      flex-basis: ", "%;\n    "], ["\n      flex-basis: ", "%;\n    "])), 100 / Math.min(count, 2) - 5);
  }, function (_a) {
    var isClickable = _a.isClickable;
    return isClickable && css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      &:hover {\n        filter: brightness(1.1);\n        ", ";\n      }\n    "], ["\n      &:hover {\n        filter: brightness(1.1);\n        ", ";\n      }\n    "])), theme.TRANSITION('color', 'filter'));
  })
});
var LinkStyles = breakpoints({
  base: css(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    margin-bottom: ", ";\n\n    ", "\n  "], ["\n    margin-bottom: ", ";\n\n    ", "\n  "])), theme.UNIT(4), function (_a) {
    var _color = _a._color;
    return _color && css(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n      color: ", ";\n      &:hover {\n        color: ", ";\n      }\n    "], ["\n      color: ", ";\n      &:hover {\n        color: ", ";\n      }\n    "])), theme.COLOR(_color), theme.COLOR(_color));
  })
});
var MoreDividerStyles = breakpoints({
  base: css(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n    margin-top: ", ";\n  "], ["\n    margin-top: ", ";\n  "])), theme.UNIT(4))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Label: styled(CellHeader)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles),
  Items: styled.ul(templateObject_14 || (templateObject_14 = __makeTemplateObject(["", ""], ["", ""])), ItemsStyles),
  Item: styled.li(templateObject_15 || (templateObject_15 = __makeTemplateObject(["", ""], ["", ""])), ItemStyles),
  Link: styled(EntityLink)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["", ""], ["", ""])), LinkStyles),
  MoreDivider: styled(MoreDivider)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["", ""], ["", ""])), MoreDividerStyles)
};
export var EntityMetaSection = function (props) {
  var _a = useComponentPropsFor('EntityMetaSection', EntityMetaSectionDefaultProps, props),
    className = _a.className,
    children = _a.children,
    label = _a.label,
    maxItems = _a.maxItems,
    items = _a.items,
    direction = _a.direction,
    color = _a.color,
    spacing = _a.spacing;
  var _b = __read(useState(false), 2),
    isExpanded = _b[0],
    setIsExpanded = _b[1];
  var hasLabel = !!label;
  var t = useLang();
  if (items.length === 0) {
    return null;
  }
  ;
  var isAside = useIsAside();
  var showAllItems = props.showAllItems || isAside;
  var primaryItems = showAllItems || isAside ? items : items.slice(0, maxItems);
  var moreItems = showAllItems ? [] : items.slice(maxItems);
  var showMoreLink = !!moreItems.length;
  var valuesComponents = useEntityTypeValues();
  var Item = function (_a) {
    var _b;
    var entity = _a.entity;
    var ValueComponent = valuesComponents[entityTypeNameFor(entity)] || EntityValue;
    var href = (entity === null || entity === void 0 ? void 0 : entity.url) || (entity === null || entity === void 0 ? void 0 : entity.path) || ((_b = entity === null || entity === void 0 ? void 0 : entity.openGraph) === null || _b === void 0 ? void 0 : _b.url);
    if (!entity) return null;
    return React.createElement(My.Item, {
      direction: direction,
      count: items.length,
      isClickable: !!href
    }, href ? React.createElement(My.Link, {
      style: {
        textDecoration: 'none'
      },
      entity: entity,
      _color: color
    }, React.createElement(ValueComponent, {
      entity: entity
    })) : React.createElement(ValueComponent, {
      entity: entity
    }));
  };
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, hasLabel && React.createElement(My.Label, null, t(label)), React.createElement(My.Items, {
    direction: direction,
    spacing: spacing
  }, compact(primaryItems.map(function (entity) {
    return React.createElement(Item, {
      key: entity.id,
      entity: entity
    });
  }))), !!moreItems.length && React.createElement(AnimateHeight, {
    duration: 300,
    easing: 'ease-out',
    height: isExpanded ? 'auto' : 0
  }, React.createElement(My.Items, {
    direction: direction,
    spacing: spacing
  }, compact(moreItems.map(function (entity) {
    return React.createElement(Item, {
      key: entity.id,
      entity: entity
    });
  })))), showMoreLink && React.createElement(My.MoreDivider, {
    count: moreItems.length,
    minimise: isExpanded,
    onClick: function (event) {
      event.stopPropagation();
      setIsExpanded(function (isExpanded) {
        return !isExpanded;
      });
    }
  }));
};
// EntityMetaSection.defaultProps = EntityMetaSectionDefaultProps;
EntityMetaSection.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17;